module.exports = __webpack_public_path__ + "img/pc_banner_agent.1751c15f.jpeg";